import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/navbar.css";

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear any authentication state or tokens if applicable (example below)
    localStorage.removeItem("authToken"); // Example for clearing auth token
    sessionStorage.removeItem("authToken"); // Example for clearing session storage token
    navigate("/login");
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">PA Polytechnic</div>
      <button className="logout-btn" onClick={handleLogout}>
        Logout
      </button>
    </nav>
  );
};

export default Navbar;
